import React, { useState } from 'react'
import MaterialTable from 'material-table'
import PropTypes from 'prop-types'

const rowColorMap = {
  1: 'white',
  2: 'yellow',
  3: 'orange',
  4: 'red'
}

const getRows = (metadata) => {
  const rows = []
  Object.keys(metadata).map(brand =>
    rows.push(getRow(brand, metadata[brand].version, metadata[brand].metadata.build)))
  return rows
}

const getRow = (brand, version, build) => {
  return {
    brand: brand,
    version: version,
    build: build
  }
}

const getVersionColorMap = (metadata) => {
  let versions = []
  Object.keys(metadata).map(brand =>
    versions.push(metadata[brand].version))
  versions = [...new Set(versions)]

  const colorMap = []
  let colorIndex = 1
  for (const i in versions.sort().reverse()) {
    colorMap[versions[i]] = colorIndex
    colorIndex++
  }
  return colorMap
}

const VersionsTable = ({ metadata, environment, refreshOnClick }) => {
  const versionColorMapIndex = getVersionColorMap(metadata)
  const [data, setData] = useState(getRows(metadata))
  return (
    <MaterialTable
      title={`Versions for ${environment.toUpperCase()} environment`}
      columns={[
        { title: 'Brand', field: 'brand' },
        { title: 'Version', field: 'version' },
        { title: 'Build', field: 'build' }
      ]}
      data={data}
      options={{
        headerStyle: { position: 'static' },
        pageSize: 10,
        actionsColumnIndex: -1,
        rowStyle: (rowData) => {
          return {
            backgroundColor: rowColorMap[versionColorMapIndex[rowData.version]]
          }
        }
      }}
      actions={[
        {
          icon: 'refresh',
          tooltip: 'Refresh Data',
          isFreeAction: true,
          onClick: () => refreshOnClick()
        }
      ]}
    />
  )
}

VersionsTable.propTypes = {
  environment: PropTypes.string.isRequired,
  metadata: PropTypes.object.isRequired,
  refreshOnClick: PropTypes.func.isRequired
}
export default VersionsTable
